<template>
  <div class="knowledge-learn 11" v-if="subjectList.length>0">
    <div class="knowledge-header" >
      <div class="knowledge-subject">
        <span class="subject-type">所属科目:</span>
        <span v-for="(item,i) in subjectList" :key="i"
        :class="[{'active':item.subject_id===subjectId},'subject-item']"
        @click="subjectClick(item)"
        >{{item.subject_name}}</span>
      </div>
      <div class="knowledge-lesson">
        <!-- <span class="subject-type">课程:</span> -->
        <div class="lesson">
            <!-- <el-select v-model="value" placeholder="全部" @change="changeCourse">
              <el-option
                v-for="item in courseList"
                :key="item.course_id"
                :label="item.course_name"
                :value="item.course_id">
              </el-option>
            </el-select> -->
            <el-date-picker
            popper-class="picker-ppp"
            @change="pickChange"
              v-model="dateRange"
              type="daterange"
              unlink-panels
              range-separator="至"
              :default-value="Date.now() - 29 * 24 * 3600 * 1000"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              >
            </el-date-picker>
        </div>
      </div>
    </div>
    <div v-if="list!==[]&&list!=={}&&subjectList.length>0">
    <StudyStatistic :subjectId="subjectId" :studyResults="studyResults"/>
    <EffectAnalysis :effect="effect" v-if="subjectId!==1&&subjectId!==3"/>
    <KnowledgeDetail
      :subjectId="subjectId"
      :detailList="detailList"
      @sizeChange="knowledgeSizeChange"
      @currentChange="knowledgeCurrentChange"
      :dataCount="dataCount"
    />
    </div>
    <div v-else>
      <Empty content="暂无数据~"/>
     </div>
  </div>
  <div v-else>
      <Empty content="暂无数据~"/>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import StudyStatistic from './study-statistic.vue';
import EffectAnalysis from './effect-analysis.vue';
import KnowledgeDetail from './knowledge-detail.vue';
import { getSubjectCourseList, tagCodeStudySituation, getKnowledgeDetailsAction } from '@/api/pt';
import { unlocking } from '@/utils/access-control';
import Empty from '@/views/pt/components/empty.vue';

export default {
  name: 'KnowledgeLearn',
  props: {
    gradeId: {
      require: true,
      default: 0,
    },
    classId: {
      require: true,
      default: 0,
    },
    masterClassId: {
      require: true,
      default: 0,
    },
  },
  data() {
    return {
      dateRange: [Date.now() - 6 * 24 * 3600 * 1000, Date.now()],
      pickerMinDate: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit('pick', [start, end]);
          },
        },
        {
          text: '最近14天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 13);
            picker.$emit('pick', [start, end]);
          },
        },
        {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
            picker.$emit('pick', [start, end]);
          },
        }],
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = minDate.getTime();
          if (maxDate) {
            this.pickerMinDate = '';
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate !== '') {
            const day30 = (30 - 1) * 24 * 3600 * 1000;
            let maxTime = this.pickerMinDate + day30;
            if (maxTime > new Date()) {
              maxTime = new Date();
              return time.getTime() > maxTime || time.getTime() < this.pickerMinDate - day30;
            }
            return maxTime < time.getTime() || time.getTime() < this.pickerMinDate - day30;
          }
          return time.getTime() > Date.now();
        },

      },
      subjectList: [], // 科目列表
      subjectId: 0, // 科目Id
      courseList: [], // 课程列表
      courseId: 0, // 课程Id
      isCharge: unlocking('Master_Sale_Manager') ? 1 : 0, // 是否管理
      studyResults: {}, // 学习成果数据
      detailList: [], // 学习详情列表
      effect: {}, // 学习效果分析
      crmSubjectId: 6012001,
      list: [],
      value: 0,
      pageSize: 10,
      currentPage: 1,
      dataCount: 0,
    };
  },
  mounted() {
    this.getSubjectList();
    console.log(this.subjectList, 'this.subjectListxxxxxxxxxx');
  },
  components: {
    StudyStatistic,
    EffectAnalysis,
    KnowledgeDetail,
    Empty,
  },
  watch: {
    classId() {
      this.subjectList = [];
      this.list = [];
      this.studyResults = {};
      this.detailList = [];
      this.effect = {};
      this.courseList = [];
      this.getSubjectList();
      this.value = 0;
      this.courseId = 0;
    },
  },
  methods: {
    getSubjectList() {
      const params = {
        class_id: this.classId,
        grade_id: this.gradeId,
        school_master_class_id: this.masterClassId,
        is_charge: unlocking('Master_Sale_Manager') ? 1 : 0,
        is_filter: 1,
      };
      getSubjectCourseList(params).then((res) => {
        if (res.code === 200) {
          this.subjectList = res.data.subject_list;
          this.$store.commit('SET_KNOW_SUBJECT_LIST', this.subjectList);
          this.subjectId = res.data.subject_list[0].subject_id;
          this.crmSubjectId = res.data.subject_list[0].crm_subject_id;
          this.getCourseList();
        }
      });
    },
    getCourseList() {
      const params = {
        class_id: this.classId,
        subject_id: this.crmSubjectId,
        grade_id: this.gradeId,
        school_master_class_id: this.masterClassId,
        is_charge: unlocking('Master_Sale_Manager') ? 1 : 0,
        is_filter: 1,
      };
      localStorage.setItem('courseParams', JSON.stringify(params));
      getSubjectCourseList(params).then((res) => {
        if (res.code === 200) {
          // this.subjectList = res.data.subject_list;
          this.courseList = res.data.course_list;
          this.$store.commit('SET_CLASS_COURSE_LIST', this.courseList);
          this.pickChange();
          this.initValue();
        }
      });
    },
    queryKnowledgeDetailsAction() {
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      const params = {
        school_id: userInfo.campusId,
        teacher_id: userInfo.id,
        class_id: this.classId,
        school_master_class_id: this.masterClassId,
        subject_id: this.subjectId,
        course_id: '',
        start_time: this.startTime,
        end_time: this.endTime,
        sort: '',
        descSort: '',
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      getKnowledgeDetailsAction(params).then((res) => {
        this.detailList = res.data.detail;
        this.dataCount = res.data.total;
      });
    },
    tagCodeStudySituation(startDate, endDate) {
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      const params = {
        school_id: userInfo.campusId,
        teacher_id: userInfo.id,
        class_id: this.classId,
        school_master_class_id: this.masterClassId,
        subject_id: this.subjectId,
        course_id: this.courseId || 0,
        start_time: startDate,
        end_time: endDate,
      };
      const knowLedgeParams = {
        school_id: userInfo.campusId,
        class_id: this.classId,
        school_master_class_id: this.masterClassId,
        subject_id: this.subjectId,
        course_id: this.courseId || 0,
        start_time: startDate,
        end_time: endDate,
        dateRange: this.dateRange,
      };
      this.$store.commit('SET_KNOWLEDGE_PARAMS', knowLedgeParams);
      tagCodeStudySituation(params).then((res) => {
        this.list = res.data;
        this.studyResults = res.data.result;
        this.effect = res.data.effect;
      });
    },
    subjectClick(item) {
      this.subjectId = item.subject_id;
      this.crmSubjectId = item.crm_subject_id;
      this.value = 0;
      this.courseId = 0;
      this.getCourseList();
    },
    pickChange() {
      const startDate = dayjs(this.dateRange[0]).format('YYYYMMDD');
      const endDate = dayjs(this.dateRange[1]).format('YYYYMMDD');
      this.$store.commit('SET_CLASS_KNOW_RANGE', this.dateRange);
      this.tagCodeStudySituation(startDate, endDate);
      this.queryKnowledgeDetailsAction();
    },
    changeCourse(item) {
      this.courseId = item;
      this.pickChange();
    },
    initValue() {
      if (this.courseList.length > 0) {
        return 0;
      }
      return '';
    },
    knowledgeSizeChange(v) {
      this.pageSize = v;
      this.queryKnowledgeDetailsAction();
    },
    knowledgeCurrentChange(v) {
      this.currentPage = v;
      this.queryKnowledgeDetailsAction();
    },
  },
};
</script>

<style lang="scss" scoped>
.knowledge-learn{
  background-color: #fff;
  padding: 0px 19px 50px 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  .knowledge-header{
    height: 155px;
    border-bottom:1px dashed #DCE1EB ;
    .knowledge-subject{
      height: 87px;
      width: 100%;
      line-height: 87px;
      .subject-type{
        font-size: 16px;
        color: #000000;
        margin-right:30px ;
      }
      .subject-item:last-child{
        font-size: 14px;
        color: #303133;
      }
      .subject-item:not(:last-child){
        font-size: 14px;
        color: #303133;
        display: inline-block;
        margin-right:52px ;
        position: relative;
        &::before{
          content: '';
          width: 4px;
          height: 4px;
          background: #C0C4CC;
          border-radius: 50%;
          left: 50px;
          top: 42px;
          position: absolute;
        }
      }
      .active{
          color: #1989FA !important;
      }
    }
    .knowledge-lesson{
      display: flex;
      .subject-type{
        width: 48px;
        height: 16px;
        line-height: 40px;
        display: inline-block;
        margin-right: 15px;
        font-size: 16px;
        color: #000000;
      }
      .lesson{
        width: 100%;
        display: flex;
        justify-content: space-between;

      }
    }
  }
}

</style>
